import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var DeleteEventImageComponent = /** @class */ (function () {
    function DeleteEventImageComponent(_matDialogRef, data, _aviationEventsService) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this.isLoading = false;
        this.aviationEvent = data.aviationEvent;
    }
    DeleteEventImageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
    };
    DeleteEventImageComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteEventImageComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._aviationEventsService.deleteEventCoverImg(this.aviationEvent.eventId, this.aviationEvent.photos[0].photoId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteEventImageComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteEventImageComponent;
}());
export { DeleteEventImageComponent };
